import { MeetingCountersResponse } from "@services/meetings/types";
import { intervalToDuration } from "date-fns";
import { useTranslation } from "react-i18next";
import { displayTime } from "@common/utils/localTime.utils";

export const useMeetingsFormatter = () => {
  const { t } = useTranslation();

  const getRealtimeMeeting = (response: MeetingCountersResponse) => {
    const realTimeCard: RealTimeCardCommonProps = {
      dataType: t("meetings"),
      loading: false,
      // TO REMOVE : wwhen we will be able to create meetings
      // button: {
      //   color: "meeting",
      // },
    };
    const dataMeetings: RealTimeMeetingDataWithLabelProps[] = [];
    const path = "/meetings";
    if ((response.futureMeetings ?? 0) > 0 && response.nextMeetingStartTime) {
      const time = displayTime(response.nextMeetingStartTime);

      const remainingTime = intervalToDuration({
        start: new Date(response.nextMeetingStartTime),
        end: new Date().setSeconds(0, 0),
      });
      dataMeetings.push({
        label: {
          text: t("next meeting"),
          color: "meeting.label",
        },
        data: {
          sub: time,
          main: `-${`${remainingTime.hours}`.padStart(
            2,
            "0"
          )}:${`${remainingTime.minutes}`.padStart(2, "0")}`,
        },
      });
    }
    dataMeetings.push(
      {
        label: {
          text: t("future"),
          color: "meeting.label",
        },
        data: {
          main: `${response.futureMeetings ?? 0}`,
        },
        url: `${path}?status=Scheduled`,
      },
      {
        label: {
          text: t("live"),
          color: "meeting.label",
        },
        data: {
          main: `${response.liveMeetings ?? 0}`,
        },
        url: `${path}?status=InProgress&status=InProgressPartial`,
      }
    );
    const data = { realTimeCard: realTimeCard, data: dataMeetings };
    return data;
  };

  return { getRealtimeMeeting };
};
